import { dialogTypes } from '@/dialogs'
import { getStore } from '@/store'
import { headerTypes } from '../enums/headerTypes'
import { RowEditorRendererBase } from './rowEditorRendererBase'
import { getExistingUserRowCodes } from '@/store/utils/reportUtils'

// Can't connect these, importing instead
import { actionCreators as dialogActions } from '@/store/Dialogs'
import { actionCreators } from '@/store/ReportSubmissions'
import { getPureMetadata } from '../core/utils'

class BranchEditorRenderer extends RowEditorRendererBase {
  createRow (value) {
    getStore().dispatch(actionCreators.createUserRow({ ...getPureMetadata(this.props),
      id: 0,
      latinName: 'userRow',
      code: `[${value}]`,
      isUserRow: true,
      definitionType: 0,
      fromDefinitionType: this.props.definitionType,
      parent: null,
      parentId: this.props.parentId,
      headerTemplateId: this.props.reportHeaderTemplateId,
      headerRenderer: null,
      type: headerTypes.Classic,
      order: this.getOrder(),
      row: this.props.row
    }))
  }

  onClick () {
    const store = getStore()
    const state = store.getState()

    store.dispatch(dialogActions.openDialog({
      dialogType: dialogTypes.branchSelector,
      reportSubmissionId: state.reportSubmissions.reportSubmission.id,
      existingCodes: getExistingUserRowCodes(state.reportSubmissions.branchDefCodes, this.props.parentId),
      onAction: value => this.createRow(value)
    }))
  }
}

export { BranchEditorRenderer }



// WEBPACK FOOTER //
// ./src/components/report-tables/headers/branchEditorRenderer.js